'use client';

import { styled } from '@mui/material/styles';

export const StyledToastContainer = styled('div')`
  & .Toastify__toast-container {
    width: fit-content;

    & .Toastify__toast {
      min-height: 0;
      background-color: #ffffff;
      padding: 0;
      border-radius: 8px;
      box-shadow: ${({ theme }) => theme.vars.customShadow?.mobileSecondary.center};
      width: fit-content;

      & .Toastify__toast-body {
        font-size: 14px;
        width: fit-content;
        min-width: 320px;
        margin: 0;
        border-left: 8px solid;
        padding: 16px 40px 16px 8px;

        & .MuiButton-root {
          font-size: 16px;
          padding: 8px 24px;
          line-height: 1.25;
        }
        div:last-of-type {
          ::before {
            font-size: 16px;
            font-weight: 500;
          }
          display: inline-flex;
          gap: 2px;
          flex-direction: column;
        }
      }

      & .close-box {
        display: flex;
        align-items: center;
        position: absolute;
        right: 4px;
        top: 0;
        bottom: 0;
      }

      &.Toastify__toast--success {
        & .Toastify__toast-body {
          background-color: ${({ theme }) => theme.palette.success[10]}15;
          color: ${({ theme }) => theme.vars.palette.success[90]};
          border-left-color: ${({ theme }) => theme.vars.palette.success[30]};

          div:last-of-type::before {
            content: 'Success';
          }

          & .Toastify__toast-icon svg {
            fill: ${({ theme }) => theme.vars.palette.success[30]};
          }

          & .MuiButton-root {
            background-color: ${({ theme }) => theme.vars.palette.success[30]};
          }
        }

        & .Toastify__progress-bar--success {
          background-color: ${({ theme }) => theme.vars.palette.success[30]};
        }

        box-shadow: var(--shadow) ${({ theme }) => theme.palette.success[30]}20;
      }

      &.Toastify__toast--warning {
        & .Toastify__toast-body {
          background-color: ${({ theme }) => theme.palette.warning[10]}15;
          color: ${({ theme }) => theme.vars.palette.warning[90]};
          border-left-color: ${({ theme }) => theme.vars.palette.warning[30]};

          div:last-of-type::before {
            content: 'Warning';
          }
        }

        & .Toastify__toast-icon svg {
          fill: ${({ theme }) => theme.vars.palette.warning[30]};
        }

        & .MuiButton-root {
          background-color: ${({ theme }) => theme.vars.palette.warning[30]};
        }

        & .Toastify__progress-bar--warning {
          background-color: ${({ theme }) => theme.vars.palette.warning[30]};
        }
        box-shadow: var(--shadow) ${({ theme }) => theme.palette.warning[30]}20;
      }

      &.Toastify__toast--error {
        & .Toastify__toast-body {
          background-color: ${({ theme }) => theme.palette.error[10]}15;
          color: ${({ theme }) => theme.vars.palette.error[90]};
          border-left-color: ${({ theme }) => theme.vars.palette.error[30]};

          div:last-of-type::before {
            content: 'Error';
          }
        }

        & .Toastify__toast-icon svg {
          fill: ${({ theme }) => theme.vars.palette.error[30]};
        }

        & .MuiButton-root {
          background-color: ${({ theme }) => theme.vars.palette.error[30]};
        }

        & .Toastify__progress-bar--error {
          background-color: ${({ theme }) => theme.vars.palette.error[30]};
        }
        box-shadow: var(--shadow) ${({ theme }) => theme.palette.error[30]}20;
      }

      &.Toastify__toast--info {
        & .Toastify__toast-body {
          background-color: ${({ theme }) => theme.vars.palette.neutral.main};
          color: #ffffff;
          border-left-color: ${({ theme }) => theme.vars.palette.neutral.main};

          div:last-of-type::before {
            content: 'Info';
          }
        }

        & .Toastify__toast-icon svg {
          fill: #ffffff;
        }

        & .MuiButton-root {
          background-color: transparent;
          color: ${({ theme }) => theme.vars.palette.primary[10]};
        }

        & .Toastify__progress-bar--info {
          background-color: #ffffff;
        }

        & svg {
          fill: #ffffff;
        }
        box-shadow: ${({ theme }) => theme.vars?.customShadow?.mobileSecondary?.center};
      }
      &:not(:first-of-type) {
        margin-top: 8px;
      }
    }

    @media only screen and (max-width: 480px) {
      left: 50% !important;
      transform: translateX(-50%) translateY(16px) !important;

      & .Toastify__toast {
        & .Toastify__toast-body {
          font-size: 12px;
          padding: 8px 40px 12px 8px;
        }
      }
    }
  }
`;
